export default {
      id: "ic_nav_coupons-usage",
      viewBox: "0 0 23 24",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_coupons-usage",
      toString: function () {
        return this.url;
      }
    }